import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { getLevel, getDataLevel as _getDataLevel } from '@/services/http';
import { dateTimeFormatter as _dateTimeFormatter, readCookie } from '@/tools/tools';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import GradeRule from '@/components/rule/gradeRule.vue';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.loading = false; // 加载
    _this.moreEquity = false;
    _this.gradeData = []; // 等级中心数据
    _this.activeIndex = 0; // 当前等级下标
    // 所有权益列表
    _this.allEquityList = [{
      code: 1,
      name: '硬件商品',
      icon: 'iconyingjian9zhe'
    }, {
      code: 2,
      name: '耗材商品',
      icon: 'iconhaocai9zhe'
    }, {
      code: 3,
      name: '硬件商品包邮',
      icon: 'iconbaoyou'
    }, {
      code: 4,
      name: '优先发货',
      icon: 'iconyouxianfahuo'
    }, {
      code: 5,
      name: '急速售后',
      icon: 'iconjisushouhou'
    }, {
      code: 6,
      name: '天无理由退货',
      icon: 'iconwuliyoutuihuo'
    }, {
      code: 7,
      name: '天无理由换货',
      icon: 'iconwuliyouhuanhuo'
    }, {
      code: 8,
      name: '生日送积分',
      icon: 'iconshengrisongjifen'
    }, {
      code: 9,
      name: '积分加成',
      icon: 'iconxingzhuangjiehe1'
    }];
    _this.equityList = []; // 显示权益列表
    _this.recordList = []; // 积分记录列表
    _this.isLoading = false; // 表格加载
    _this.ruleList = []; // 积分规则列表
    // 用户积分等级
    _this.level = 0;
    _this.nextLevelList = []; // 当前等级可升级的列表
    _this.currentpage = 1; // 当前页数
    _this.totalnumber = 10; // 总条数
    _this.pageNo = 1; // 当前页
    _this.pageSize = 10; // 当前条数
    _this.showRule = false; // 是否显示规则说明
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function () {
      var _created = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getData();
            case 2:
              // 等级中心数据
              this.getDataLevel(); // 1.53埋点
              // await this.getRecordList(); // 积分记录列表 2020.7.10更改
              // await this.getRuleList(); // 积分规则列表 2020.7.10更改
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function created() {
        return _created.apply(this, arguments);
      }
      return created;
    }() // 切换标签页
  }, {
    key: "changeActiveIndex",
    value: function changeActiveIndex(index) {
      this.activeIndex = index;
      this.getEquityList();
    }
    // handleSizeChange(pageSize: number) {
    //   this.pageSize = pageSize;
    //   this.getRecordList();
    // }
    // handleCurrentChange(pageNo: number) {
    //   this.pageNo = pageNo;
    //   this.getRecordList();
    // }
    // 获取等级中心信息
  }, {
    key: "getData",
    value: function () {
      var _getData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.loading = true;
              _context2.next = 3;
              return getLevel({
                companyId: 1
              });
            case 3:
              res = _context2.sent;
              if (res.data.code === 100) {
                this.gradeData = res.data.data;
                this.level = res.data.data.level;
                this.moreEquity = true;
                // 格式化当前等级可升级的列表
                this.nextLevelList = this.gradeData.levelList.filter(function (e) {
                  return e.level >= res.data.data.level;
                });
                this.nextLevelList = this.nextLevelList.map(function (item) {
                  var data = item;
                  data.num = item.equity ? item.equity.split(',') : [];
                  data.num = data.num.map(parseFloat);
                  return data;
                });
                this.getEquityList();
                this.gradeData.growthRuleList = this.gradeData.growthRuleList.map(function (item) {
                  var data = item;
                  data.list = item.rules ? item.rules.split(',') : [];
                  data.list = data.list.map(parseFloat);
                  return data;
                });
              } else {
                this.$message.error(res.data.message);
              }
              this.loading = false;
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getData() {
        return _getData.apply(this, arguments);
      }
      return getData;
    }() // 获取积分记录列表
    // private async getRecordList() {
    //   const res: any = await getIntegral({
    //     pageNo: this.pageNo,
    //     pageSize: this.pageSize
    //   });
    //   if (res.data.code === 100) {
    //     this.recordList = res.data.data.list;
    //     this.totalnumber = res.data.data.total;
    //   } else {
    //     (this as any).$message.error(res.data.message);
    //   }
    // }
    // 获取当前等级下的权益列表
  }, {
    key: "getEquityList",
    value: function getEquityList() {
      this.equityList = [];
      for (var i = 0; i < this.allEquityList.length; i += 1) {
        for (var j = 0; j < this.nextLevelList[this.activeIndex].num.length; j += 1) {
          if (this.allEquityList[i].code === this.nextLevelList[this.activeIndex].num[j]) {
            this.equityList.push(this.allEquityList[i]);
          }
        }
      }
    }
    // 获取积分规则列表
    // private async getRuleList() {
    //   const res: any = await getIntegralRule();
    //   if (res.data.code === 100) {
    //     this.ruleList = res.data.data.ruleList;
    //   } else {
    //     this.$message.error(res.data.message);
    //   }
    // }
    // 1.53埋点
  }, {
    key: "getDataLevel",
    value: function getDataLevel() {
      var anchor = readCookie('anchor');
      _getDataLevel({
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        src: anchor ? anchor.src ? anchor.src : 2 : 4,
        model: anchor ? anchor.model : '',
        equipVersion: anchor ? anchor.equipVersion : '',
        equipMeid: anchor ? anchor.equipMeid : '',
        eventNo: '3.1.1.0.0.0.1',
        level: this.level,
        companyId: 1
      });
    }
  }]);
}(Vue);
__decorate([State('user')], default_1.prototype, "data", void 0);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    NavMenu: NavMenu,
    GradeRule: GradeRule
  },
  filters: {
    dateTimeFormatter: function dateTimeFormatter(value) {
      return _dateTimeFormatter(value);
    }
  }
})], default_1);
export default default_1;